import { render, staticRenderFns } from "./courseDetailNew.vue?vue&type=template&id=2d987bd4&scoped=true"
import script from "./courseDetailNew.vue?vue&type=script&lang=js"
export * from "./courseDetailNew.vue?vue&type=script&lang=js"
import style0 from "./courseDetailNew.vue?vue&type=style&index=0&id=2d987bd4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d987bd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d987bd4')) {
      api.createRecord('2d987bd4', component.options)
    } else {
      api.reload('2d987bd4', component.options)
    }
    module.hot.accept("./courseDetailNew.vue?vue&type=template&id=2d987bd4&scoped=true", function () {
      api.rerender('2d987bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/keeCourses/courseDetailNew.vue"
export default component.exports